import { createFileRoute } from '@tanstack/react-router';

import { useLandingRedirect } from '../../auth/use-landing-redirect.js';
import { LoadFailedArea, LoadingArea } from '../../components/PlaceholderPage.js';

/**
 * The start URL. It shows nothing of its own: it asks the backend where this
 * Account User lands and replaces itself with that page
 * (`ux.md`, Destinations, "Start").
 */
export const Route = createFileRoute('/_app/')({
  component: StartPage,
});

function StartPage() {
  const landing = useLandingRedirect(true);

  if (landing.kind === 'failed') return <LoadFailedArea onRetry={landing.retry} />;
  return <LoadingArea />;
}
